document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('search-input');
  const liveResults = document.getElementById('live-search-results');
  const liveProducts = document.getElementById('live-search-products');
  const liveLoading = document.querySelector('.live-search-loading');
  const viewAllContainer = document.getElementById('live-search-view-all');
  const viewAllLink = document.querySelector('.view-all-link');
  
  let searchTimeout;
  let currentQuery = '';

  if (!searchInput) return;

  // Show/hide results
  function showResults() {
    liveResults.style.display = 'flex';
  }

  function hideResults() {
    liveResults.style.display = 'none';
  }

  function showLoading() {
    liveLoading.style.display = 'block';
    liveProducts.innerHTML = '';
    viewAllContainer.style.display = 'none';
    liveResults.style.display = 'none';
  }

  function hideLoading() {
    liveLoading.style.display = 'none';
  }

  // Perform search
  function performSearch(query) {
    if (query.length < 2) {
      hideResults();
      return;
    }

    currentQuery = query;
    showResults();
    showLoading();

    // Use Shopify's search endpoint
    fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=10`)
      .then(response => response.json())
      .then(data => {
        hideLoading();
        
        if (data.resources && data.resources.results && data.resources.results.products) {
          displayResults(data.resources.results.products, query);
        } else {
          // Fallback to regular search API
          fetch(`/search?q=${encodeURIComponent(query)}&type=product&view=json`)
            .then(response => response.text())
            .then(html => {
              displayNoResults();
            })
            .catch(error => {
              console.error('Search error:', error);
              displayNoResults();
            });
        }
      })
      .catch(error => {
        console.error('Search error:', error);
        hideLoading();
        displayNoResults();
      });
  }

  // Sort products with bestsellers first (you'll need to implement bestseller logic)
function sortProductsWithBestsellers(products) {
  return products.sort((a, b) => {
    // Check if product has "Best Sellers" tag (case insensitive)
    const aIsBestseller = a.tags && a.tags.some(tag => 
      tag.toLowerCase() === 'best sellers' || tag.toLowerCase() === 'best seller'
    );
    const bIsBestseller = b.tags && b.tags.some(tag => 
      tag.toLowerCase() === 'best sellers' || tag.toLowerCase() === 'best seller'
    );
    
    // Bestsellers come first
    if (aIsBestseller && !bIsBestseller) return -1;
    if (!aIsBestseller && bIsBestseller) return 1;
    return 0;
  });
}

// Also update the displayResults function to use the same logic:
function displayResults(products, query) {
  if (!products || products.length === 0) {
    hideResults();
    return;
  }

  // Sort products with bestsellers first and limit to 4
  const sortedProducts = sortProductsWithBestsellers(products).slice(0, 4);

  let html = '';

  sortedProducts.forEach((product, index) => {
    // Check for "Best Sellers" tag
    const isBestseller = product.tags && product.tags.some(tag => 
      tag.toLowerCase() === 'best sellers' || tag.toLowerCase() === 'best seller'
    );

    const price = product.price ? Math.round(Number(product.price)) : '';
    const comparePrice = product.compare_at_price && Number(product.compare_at_price) > Number(product.price)
      ? Math.round(Number(product.compare_at_price))
      : null;

    html += `
      <a href="${product.url}" class="live-search-product">
        <div class="live-search-product-image">
          <img src="${(product.image && product.image.src) ? product.image.src : (product.image ? product.image : '/assets/no-image.png')}" 
               alt="${product.title}" 
               loading="lazy">
        </div>
        <div class="live-search-product-info">
          <div class="best-seller-holder">
            ${isBestseller ? '<p class="ribbon-subhead">Best Seller</p>' : ''}
          </div>
          <h4 class="live-search-product-title">
            ${product.title}
          </h4>
          <p class="live-search-product-price">
            ${comparePrice ? `<span style="text-decoration: line-through; color: #999;">$${comparePrice}</span> ` : ''}
            ${price ? `$${price}` : 'Price unavailable'}
          </p>
        </div>
      </a>
    `;
  });

  liveProducts.innerHTML = html;
  liveResults.style.display = 'flex';

  // Show "View all results" link
  viewAllLink.href = `/search?type=product&q=${encodeURIComponent(query)}`;
  viewAllContainer.style.display = 'block';
}

  function displayNoResults() {
  hideResults();
  }

  // Event listeners
  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();
    
    // Clear previous timeout
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    // Debounce search
    searchTimeout = setTimeout(() => {
      performSearch(query);
    }, 300);
  });

  searchInput.addEventListener('focus', function() {
    if (currentQuery.length >= 2) {
      showResults();
    }
  });

  // Hide results when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.search-holder')) {
      hideResults();
    }
  });

  // Prevent form submission when clicking on results
  liveResults.addEventListener('click', function(e) {
    e.stopPropagation();
  });
});